export default {
      id: "anquan-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "static/img/icons.d90c56e0.svg#anquan",
      toString: function () {
        return this.url;
      }
    }